import React, { Component } from "react";

class FlexibleSigmoidoscopy extends Component {
    render() {
      return (
        <>
            <h4>Flexible Sigmoidoscopy</h4>

            <div className="video-container">
            <iframe width="560" height="315" src="https://www.youtube.com/embed/d-vGeNDlhA0?si=NsAmGWlhJPNxXuga" title="flexible sigmoidography video" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>            </div>
            <p>Flexible sigmoidoscopy
            (SIG-moy-DAH-skuh-pee) enables the
            physician to look at the inside of the large
            intestine from the rectum through the last
            part of the colon, called the sigmoid or
            descending colon. Physicians may use
            the procedure to find the cause of
            diarrhea, abdominal pain, or
            constipation. They also use it to look for
            early signs of cancer in the descending
            colon and rectum. With flexible
            sigmoidoscopy, the physician can see
            bleeding, inflammation, abnormal
            growths, and ulcers in the descending
            colon and rectum. Flexible
            sigmoidoscopy is not sufficient to detect
            polyps or cancer in the ascending or
            transverse colon (two-thirds of the
            colon).</p>

            <p>For the procedure, you will lie on your
            left side on the examining table. The
            physician will insert a short, flexible,
            lighted tube into your rectum and slowly
            guide it into your colon. The tube is
            called a sigmoidoscope
            (sig-MOY-duh-skope). The scope
            transmits an image of the inside of the
            rectum and colon, so the physician can
            carefully examine the lining of these
            organs. The scope also blows air into
            these organs, which inflates them and
            helps the physician see better.</p>

            <p>If anything unusual is in your rectum or
            colon, like a polyp or inflamed tissue, the	physician can remove a piece of it using instruments inserted into the scope. The physician
            will send that piece of tissue (biopsy) to the lab for testing.</p>

            <p>Bleeding and puncture of the colon are possible complications of sigmoidoscopy.
            However, such complications are uncommon.</p>

            <p>Flexible sigmoidoscopy takes 10 to 20 minutes. During the procedure, you might feel
            pressure and slight cramping in your lower abdomen. You will feel better afterward when
            the air leaves your colon.</p>

            <h4>Preparation</h4>

            <p>Right before the
            procedure, you will be asked to take an enema, which is a liquid solution that washes out the
            lower colon and rectum. Your physician may give you other special instructions.</p>
        </>
      );
    }
  }
   
  export default FlexibleSigmoidoscopy;